import { render, staticRenderFns } from "./ModeNav.vue?vue&type=template&id=5f3710d7&scoped=true"
import script from "./ModeNav.vue?vue&type=script&lang=js"
export * from "./ModeNav.vue?vue&type=script&lang=js"
import style0 from "./ModeNav.vue?vue&type=style&index=0&id=5f3710d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3710d7",
  null
  
)

export default component.exports